import React, { Component } from 'react';
import { connect } from 'react-redux';
import {TweenMax, TimelineMax} from 'gsap';
import fa from '@fortawesome/fontawesome';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SolidIcons from '@fortawesome/fontawesome-free-solid'

export default class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      error: "",
      valid: this.props.isRequired && this.props.isRequired !== false ? false : true,
      showError: false
    }
  }

  componentDidMount() {
    fa.library.add(SolidIcons);
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
    if (this.props.showError === true && this.state.showError === false) {
      this.validate(this.Input);
    }
    this.adjustErrorHeight();
  }

  componentWillUnmount() {
    this.state = {};
  }

  getIcon = () => {
    return fa.findIconDefinition({iconName: this.props.icon})
  }

  handleChange = (e) => {
    this.validate(e.target);
    this.props.onChange && this.props.onChange(e, this);
  }

  adjustErrorHeight = () => {
    if (this.state.showError && this.state.error !== "") {
      TweenMax.to(this.container, 0.25, {marginBottom: (this.error.getBoundingClientRect().height - 4)})
    } else {
      TweenMax.to(this.container, 0.25, {marginBottom: 0})
    }
  }

  validate = (target) => {
    if (!target) return;
    if (this.props.isRequired) {
      var valid = true, errMsg = "";
      if (target.value.length === 0) {
        valid = false;
        errMsg = "Required";
      } else {
        if (!this.props.skipValidation) {
          switch (this.props.type) {
            case "password":
              if (this.props.compareTo) {
                if (target.value !== this.props.compareTo) {
                  valid = false;
                  errMsg = "Passwords do not match. Please try again.";
                }
              } else if (target.value.length < 6 || target.value.length > 32) {
                valid = false;
                errMsg = "Password length must be between 6 and 32";
              }
              break;
            case "email":
              if (!target.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                valid = false;
                errMsg = "Please enter a valid email address";
              }
              break;
            case "phone":
              if (!target.value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)) {
                valid = false;
                errMsg = "Please enter a valid phone number (eg. 123-456-7890)";
              }
              break;
            default:
          }
        }
      }
      this.setState({value: target.value, error: errMsg, valid: valid, showError: true});
    } else if (this.props.format && target.value){
      // if (this.props.format === 'currency') {
      //   var val = StrUtils.getNumbers(target.value);
      //   this.setState({value: val, error: "", valid: true, showError: true});
      // }
    } else {
      this.setState({value: target.value, error: "", valid: true, showError: true});
    }
  }

  format = (value) => {
    if (value.length === 0) return value;
    if (this.props.format) {
      switch (this.props.format.toLowerCase()) {
        case "currency": {
          var firstCommaPos = value.length % 3,
              result = "$ ";

          if (value.length <= 3) return result + value;
          if (firstCommaPos > 0) {
            result += value.slice(0, firstCommaPos);
            result += ",";
          }
          for (var i = firstCommaPos; i < value.length; i++) {
            if (i > firstCommaPos) {
              result += ",";
            }
            result += value.slice(i, i + 3);
            i += 2;
          }
          return result;
          break;
        }
        default:
      }
    }

    return value;
  }

  getStyle = () => {
    var style = ""
    style = this.props.style ? this.props.style.toLowerCase() : "";
    return style;
  }

  toggleFocus = (on) => {
    if (on) {
      if (this.container.className.indexOf("focused") == -1)
        this.container.className += " focused";
    } else {
      this.container.className = this.container.className.replace(" focused", "");
    }
  }

  render() {
    return (
      <div className={"InputField " + this.getStyle()} ref={el => this.container = el}>
        { this.props.icon &&
          <div className={"input-icon" + (this.props.mirrored ? " mirrored" : "")}>
            <FontAwesomeIcon icon={this.getIcon()} />
          </div>
        }
        <label>
          <span className="Label">
            {this.state.value === "" && this.props.label}
          </span>
          {this.state.showError && this.state.error !== "" ? <span className="error" ref={el => this.error = el}>{this.state.error}</span> : ""}
          <input value={this.format(this.state.value)}
                 id={this.props.id}
                 ref={el => this.Input = el}
                 onChange={this.handleChange}
                 className="TextField"
                 onFocus={this.toggleFocus.bind(this, true)}
                 onBlur={this.toggleFocus.bind(this, false)}
                 type={this.props.type || "text"} />
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/InputField/InputField.js